export const updateFieldById = (items, id, updates) => {
    return items.map(item => {
      if (item.id === id) {
        return { ...item, ...updates };
      }
  
      if (
        item.inputType?.toLowerCase() === "panel" &&
        Array.isArray(item.fields) &&
        item.fields.length > 0
      ) {
        return {
          ...item,
          fields: updateFieldById(item.fields, id, updates),
        };
      }
  
      return item;
    });
  };
  